export const GET_REPORTS = 'GET_REPORTS'
export const GET_REPORT = "GET_REPORT"
export const DELETE_REPORT= 'DELETE_REPORT'

